import { render } from "./ViewCatalogs.vue?vue&type=template&id=26317fbe&scoped=true&ts=true"
import script from "./ViewCatalogs.vue?vue&type=script&lang=ts"
export * from "./ViewCatalogs.vue?vue&type=script&lang=ts"

import "./ViewCatalogs.vue?vue&type=style&index=0&id=26317fbe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26317fbe"]])

export default __exports__